<template>
	<div id="systemmodule">
		<HrrBreadcrumb PMname="信息管理" CMname="用户站点管理" />
		<HrrMainLayout>
			<template slot="searh">
				<el-form :inline="true" :model="searchform">
					<el-form-item >
						<el-input v-model="keyword" placeholder="关键字" >
							<el-select v-model="selectfield" slot="prepend" placeholder="请选择" class="input-with-select">
						      <el-option label="名称" value="siteName"></el-option>
						      <el-option label="描述" value="siteDesc"></el-option>
						    </el-select>
						</el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit">查询</el-button>
					</el-form-item>
				</el-form>
			</template>
			<template slot="buttons">
				<el-button-group>
					<el-button type="primary" icon="el-icon-edit" size="small" @click="Addclick" v-if="isHadFun('Add')">新增</el-button>
					<el-button type="primary" icon="el-icon-edit-outline" size="small" @click="editclick" v-if="isHadFun('Update')">编辑</el-button>
					<el-button type="primary" icon="el-icon-delete" size="small" @click="delclick" v-if="isHadFun('Delete')">删除</el-button>
					<el-button type="primary" icon="fa fa-check-square-o" size="small" v-if="false">审核</el-button>
				</el-button-group>
			</template>
			<template slot="table">
				<el-table  :data="tableData" ref="Opentable" :cell-style="cellStyle" @cell-click="cellclick" @selection-change="selectionchange"
				border 
				stripe 
				style="width: 100%" 
				v-loading="loading"  >
				<el-table-column type="selection" width="55" fixed="left">
				</el-table-column>
				<el-table-column  type="index" label="序号" width="50" fixed="left" sortable>
				</el-table-column>
				<el-table-column prop="siteName" label="站点名称" width="140" fixed="left" sortable >
				</el-table-column>
				<el-table-column prop="siteDesc" label="站点描述" width="200">
				</el-table-column>
				<el-table-column prop="floor" label="楼层数" width="100">
				</el-table-column>
				<el-table-column prop="siteType" label="站点类型" width="120">
				</el-table-column>
				<el-table-column prop="lon" label="经度" width="120" >
				</el-table-column>
				<el-table-column prop="lat" label="纬度" width="120">
				</el-table-column>
				<el-table-column prop="provinceId" label="省" width="120">
				</el-table-column>
				<el-table-column prop="cityId" label="市" width="120">
				</el-table-column>
				<el-table-column prop="countyId" label="区" width="120">
				</el-table-column>
				<el-table-column prop="siteAddress" label="地址" width="170">
				</el-table-column>
				<el-table-column prop="creationDate" label="创建时间" width="200" sortable>
				</el-table-column>
				<el-table-column prop="creationBy" label="创建人" width="100">
				</el-table-column>
				<el-table-column prop="lightBoxNum" label="使用媒体数"  width="100" fixed="right">
				</el-table-column>
				<el-table-column prop="deviceNum" label="使用设备数" width="100" fixed="right">
				</el-table-column>
				<el-table-column label="状态" width="100" align="center" fixed="right" >
                    <template slot-scope="scope">
                        <el-tag  type="danger" disable-transitions v-if="scope.row.status==0" >禁用</el-tag>
                        <el-tag  type="success" disable-transitions v-if="scope.row.status==1" >启用</el-tag>
                    </template>
                </el-table-column>
				<el-table-column label="操作" width="180" fixed="right">
					<template slot-scope="scope">
						<el-button @click.stop="Rowview(scope.row)" type="text" size="small" v-if="isHadFun('See')">查看</el-button>
						<el-button @click.stop="RowEdit(scope.row)" type="text"  size="small" v-if="isHadFun('Update')">编辑</el-button>
						<el-button @click.stop="Rowdelete(scope.row)" type="text"  size="small" v-if="isHadFun('Delete')">删除</el-button>
						<el-button @click.stop="Rowlightbox(scope.row)" type="text"  size="small" v-if="isHadFun('SiteLookLightBox')">查看媒体</el-button>
					</template>
				</el-table-column>
			</el-table>
		</template>
		<template slot="Pagination">
			<el-pagination
			background
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:current-page="searchform.pageNum"
			:page-sizes="[5, 10, 15]"
			layout="total, sizes, prev, pager, next, jumper"
			:total="total">
		</el-pagination>
	</template>
</HrrMainLayout>
</div>
</template>
<script>
	export default {
		name: 'site_info',
		data(){
			return{
				searchform:{
					pageNum:1,
					pageSize:10,
					siteDesc:"",
					siteName:"",
				},
				tableData:[],
				total:0,
				loading:true,
				selectionRows:[],
				selectfield:"siteName",
				keyword:"",
				dialogVisible:false
			}
		},
		methods:{
			onSubmit(){
				this.searchform.siteName="";
				this.searchform.siteDesc="";
				this.searchform.pageNum = 1;
				this.searchform[this.selectfield]=this.keyword.trim();
				this.initData();
			},
			handleSizeChange(val) {
				this.searchform.pageSize=val;
				this.initData();
			},
			handleCurrentChange(val) {
				this.searchform.pageNum=val;
				this.initData();
			},
			Rowview(val){
				this.$route.meta.row=val;
				this.$route.meta.searchform=this.searchform;
				this.$router.push({path:'/site/info/view/'+val.siteId});
			},
			RowEdit(val){
				this.$route.meta.row=val;
				this.$route.meta.searchform=this.searchform;
				this.$router.push({path:'/site/info/edit/'+val.siteId});
			},
			Rowdelete(val){
				this.$confirm("确定要删除 '"+val.siteName+"' 此记录么？","删除提示",{type:"warning"})
				.then(()=>{
					var Vuethis=this;
					this.$hrraxios({
                        method: "delete",
                        url:this.$api.site.DelSite+"/"+val.siteId})
					.then((response)=>{
						var redata=response.data;
						if(redata.Success==true){
							Vuethis.$message({message:"删除成功！",type:"success"});
							Vuethis.initData();
						}else{
							Vuethis.$message({message:redata.Prompt,type:"error"});
						}
					})
				}).catch((error)=>{
					console.log(error);
				});
			},
			Rowlightbox(val){
				this.$store.commit('setsiteInfo',val);
				//this.$router.push({path:'/site/customlightbox/'+val.siteId});
				this.$router.push({path:'/lightbox/infoforsite/'+val.siteId});
			},
			RowSendcmd(val){
				this.dialogVisible=true;
				this.cmdform.MN=val.Device_Code;
			},
			cellclick(row, column, cell, event){
				if(column.label=="使用媒体数"){
					this.$common.getSeeFunListByMCode(this,"LightBoxInfo",(callback)=>{
						if(callback.length!=0){
							this.$router.push({path:'/lightbox/infoforsite/'+row.siteId});
						}else{
							this.$message({message:"抱歉，您没有查看媒体权限",type:"warning"});
						}
					});
				}
				if(column.label=="使用设备数"){
					this.$common.getSeeFunListByMCode(this,"DeviceInfo",(callback)=>{
						if(callback.length!=0){
							this.$router.push({path:'/device/infoforsite/'+row.siteId});
						}else{
							this.$message({message:"抱歉，您没有查看设备权限",type:"warning"});
						}
					});
				}
				this.$refs.Opentable.toggleRowSelection(row);
			},
			Addclick(){
				this.$route.meta.searchform=this.searchform;
				this.$router.push({path:'/site/info/add/',});
			},
			handleClick(tab, event) {
                console.log(tab, event);
            },
			pubclick(){
				if(this.selectionRows.length==0)
				{
					this.$message({message:"请先选择一行在操作",type:"warning"});
					return;
				}
			},
			editclick(){
				if(this.selectionRows.length==0)
				{
					this.$message({message:"请先选择一行在操作",type:"warning"});
					return;
				}
				if(this.selectionRows.length>1)
				{
					this.$message({message:"只能操作一行数据",type:"warning"});
					return;
				}
				this.$route.meta.row=this.selectionRows[0];
				this.$route.meta.searchform=this.searchform;
				this.$router.push({path:'/site/info/edit/'+this.selectionRows[0].siteId});
			},
			delclick(){
				if(this.selectionRows.length<1)
				{
					this.$message({message:"请先选择一行在删除",type:"warning"});
					return;
				}
				this.$confirm("确定要删除这些记录么？",{type:"warning"})
				.then(()=>{
					var loading = this.$loading({
						lock: true,
						text: '删除中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					var Vuethis=this;
					var PostfunArr=[];
					this.selectionRows.forEach(myrow=>{
						var postRe=this.$hrraxios({
                        method: "delete",
                        url:this.$api.site.DelSite+"/"+myrow.siteId})
						PostfunArr.push(postRe);
					});
					this.$axios.all(PostfunArr)
					.then(this.$axios.spread(function(){
						loading.close();
						//console.log(arguments);
						var isalldel=true;
						for(var i=0;i<arguments.length;i++){
							if(arguments[i].data.Success==false)
							{
								isalldel=false;
							}
						}
						if(isalldel==true){
							Vuethis.$message({message:"全部删除成功！",type:"success"});
							Vuethis.initData();
						}else{
							//有删除失败的未处理
						}
					}));
				})
				.catch((error)=>{
					
				});
			},
			cellStyle(row,column,rowIndex,columnIndex){
				if(row.column.label==="使用媒体数"||row.column.label==="使用设备数"){
					return 'font-weight: bolder;color:#ff9c70;text-align:center'
				}
			},
			selectionchange(selection){
				this.selectionRows=selection;
			},
			initData(){
				var Vuethis=this;
				this.loading=true;
				//this.$hrraxios.get(this.$api.device.getdeviceList, {params:this.searchform})
				this.$hrraxios.get(this.$api.site.api, {params:this.searchform})
				.then(function (response) {
					Vuethis.loading=false;
					var data=response.data;
					if(data.Success==true)
					{
						Vuethis.tableData=data.Data.List;
						Vuethis.total=data.Data.Total;
					}else{
						Vuethis.$message.error(data.Prompt);
					}
				})
				.catch(function (error) {
					Vuethis.loading=false;
					console.log(error);
				});
			},
			initParamsData(){
				//this.$common.getplanlist(this,"planIdData");
				//this.$common.getFunListByMCode(this,"PlanOpen");
			}
		},
		beforeRouteLeave(to, from, next) {
			// 导航离开该组件的对应路由时调用
			to.meta.row=from.meta.row;
			to.meta.searchform=from.meta.searchform;
			next();
		},
		created(){
			this.$common.getFunListByMCode(this,"CustomSite",()=>{
				if(this.$route.meta.searchform !=undefined){
					var searchformData=this.$route.meta.searchform
					this.searchform.pageNum=searchformData.pageNum;
					this.searchform.pageSize=searchformData.pageSize;
					if(searchformData.siteName!=""){
						this.selectfield="siteName";
						this.keyword=searchformData.siteName;
						this.searchform.siteName=searchformData.siteName;
					}else if(searchformData.siteDesc!=""){
						this.selectfield="siteDesc";
						this.keyword=searchformData.siteDesc;
						this.searchform.siteDesc=searchformData.siteDesc;
					}
				}
				this.initData();
				this.initParamsData();
			});
		}
	}
</script>
<style >
  .input-with-select { width: 110px;}
	.educard label {color: #99a9bf;}
	.educard{margin-bottom: 10px;}
	.utable .el-button,.utable .el-button+.el-button{margin-right: 10px;margin-left: 0;}
  #lightForm .el-select{width: 100px;}
</style>
